// The one place the UI reads the application version from: the `version` of
// this package (packages/app/package.json). Bump it there when cutting a
// release (see CHANGELOG.md); nothing else needs to change.
import { version } from '../../package.json';

export const APP_VERSION: string = version;
